<template>
  <div id="app" class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950">
    <!-- Navigation Bar -->
    <nav-bar v-if="$store.state.admin != '' && $route.name != 'login'" />
    
    <!-- Toasts & Confirm -->
    <toast />
    <confirm-dialog />

    <!-- Main Content -->
    <main :class="['flex-1 text-gray-900 dark:text-gray-100', ($store.state.admin != '' && $route.name != 'login') ? 'pt-16 lg:pl-64' : '']">
      <router-view />
    </main>
    
    <!-- Footer -->
    <footer v-if="$store.state.admin != '' && $route.name != 'login'" class="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 py-4 mt-auto">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center text-sm text-gray-500 dark:text-gray-400">
          <span v-if="2022 == new Date().getFullYear()">
            &copy;{{ new Date().getFullYear() }} Fira Sport. All Rights Reserved
          </span>
          <span v-else>
            &copy;2022 - {{ new Date().getFullYear() }} Fira Sport. All Rights Reserved
          </span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Toast from "./components/Toast.vue";
import ConfirmDialog from "./components/ConfirmDialog.vue";
import navBar from "./components/navBar.vue";

export default {
  components: {
    Toast,
    ConfirmDialog,
    navBar,
  },
  data: () => ({
    //
  }),
};
</script>

<style>
/* Global styles */
#app {
  font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Smooth transitions */
* {
  transition: all 0.2s ease-in-out;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
